<onyx-section [heading]="`${I18N}.heading`">
  @if (!readonly()) {
    <div rightHeading class="heading">
      <onyx-icon name="tooltip-filled" [size]="16"></onyx-icon>

      <p>{{ `${i18n()}.warning` | translate }}</p>
    </div>
  }

  <div class="container">
    @if (vehicleTypesCompatibility(); as compatibility) {
      @let type = compatibility.compatibleTypes.length ? 'warning' : 'error';
      <onyx-message [intent]="type">
        <onyx-icon
          [name]="
            type === 'error' ? 'error-filled' : 'alert-circle-two-tone-filled'
          "
          [size]="20"
        ></onyx-icon>

        <p>
          @if (compatibility.compatibleTypes.length) {
            {{ `${I18N}.compatibleTypes` | translate }}
            <span class="f-paragraph-s f-semibold">
              <ng-container
                *ngTemplateOutlet="
                  typesTemplate;
                  context: { types: compatibility.compatibleTypes }
                "
              ></ng-container>
            </span>
          } @else {
            {{ `${I18N}.noCompatibleTypes` | translate }}
          }
        </p>

        <ul description>
          @for (
            conflictParameter of compatibility.conflictParameters;
            track conflictParameter[0]
          ) {
            <li>
              {{ `labels.${conflictParameter[0]}` | translate }}:
              <ng-container
                *ngTemplateOutlet="
                  typesTemplate;
                  context: { types: conflictParameter[1] }
                "
              ></ng-container>
            </li>
          }

          @for (
            conflictDischargeType of compatibility.conflictDischargeTypes;
            track conflictDischargeType[0]
          ) {
            <li>
              {{ 'labels.dischargeType' | translate }} ({{
                `${DictionaryCode.DISCHARGE_TYPE}.${conflictDischargeType[0]}`
                  | translate
                  | lowercase
              }}):
              <ng-container
                *ngTemplateOutlet="
                  typesTemplate;
                  context: { types: conflictDischargeType[1] }
                "
              ></ng-container>
            </li>
          }
        </ul>

        @if (compatibility.compatibleTypes.length) {
          <p description>
            {{ `${I18N}.incompatibleTypes` | translate }}
            <ng-container
              *ngTemplateOutlet="
                typesTemplate;
                context: { types: compatibility.incompatibleTypes }
              "
            ></ng-container>
          </p>
        }

        <ng-template let-types="types" #typesTemplate>
          @for (type of types; track type) {
            {{ `${DictionaryCode.VEHICLE_TYPE}.${type}` | translate
            }}{{ !$last ? ', ' : '' }}
          }
        </ng-template>
      </onyx-message>
    }

    @let controls = form().controls;
    <form [formGroup]="form()">
      <div class="parameters">
        @if (
          showAdrClasses() &&
          shouldDisplayControl(controls.adrClasses, { conditional: true })
        ) {
          <div class="item" [style.order]="order()['labels.adr']">
            <onyx-toggle
              data-testid="has-adr-classes-toggle"
              [(checked)]="hasAdrClasses"
              label="labels.adr"
              [size]="32"
              [disabled]="readonly()"
            ></onyx-toggle>

            @if (hasAdrClasses()) {
              <onyx-dropdown
                data-testid="adr-classes-dropdown"
                [formControl]="controls.adrClasses"
                placeholder="labels.adrClass"
                [options]="adrClasses$ | async"
                [multiple]="true"
                [search]="true"
                [size]="32"
                [showErrors]="false"
              ></onyx-dropdown>
            }
          </div>
        }

        @if (shouldDisplayControl(controls.hasSafeParking)) {
          <onyx-toggle
            data-testid="has-safe-parking-toggle"
            [style.order]="order()['labels.safeParking']"
            [formControl]="controls.hasSafeParking!"
            label="labels.safeParking"
            [size]="32"
          ></onyx-toggle>
        }

        @let isOrder = type() === 'order';
        @if (
          isOrder &&
          shouldDisplayControl(controls.minEmissionStandard, {
            conditional: true,
          })
        ) {
          <div class="item" [style.order]="order()['labels.emissionStandard']">
            <onyx-toggle
              data-testid="has-min-emission-standard-toggle"
              [(checked)]="hasMinEmissionStandard"
              label="labels.emissionStandard"
              [size]="32"
              [disabled]="readonly()"
            ></onyx-toggle>

            @if (hasMinEmissionStandard()) {
              <onyx-dropdown
                data-testid="min-emission-standard-dropdown"
                [formControl]="controls.minEmissionStandard!"
                [options]="emissionStandards$ | async"
                [size]="32"
                [showErrors]="false"
              ></onyx-dropdown>
            }
          </div>
        }

        @if (isOrder && shouldDisplayControl(controls.requiresDidb)) {
          <onyx-toggle
            data-testid="requires-didb-toggle"
            [style.order]="order()['labels.didb']"
            [formControl]="controls.requiresDidb!"
            label="labels.didb"
            [size]="32"
          ></onyx-toggle>
        }

        @if (
          isOrder &&
          shouldDisplayControl(controls.fuelTypes, { conditional: true })
        ) {
          <div class="item" [style.order]="order()['labels.fuelTypes']">
            <onyx-toggle
              data-testid="has-fuel-types-toggle"
              [(checked)]="hasFuelTypes"
              label="labels.fuelTypes"
              [size]="32"
              [disabled]="readonly()"
            ></onyx-toggle>

            @if (hasFuelTypes()) {
              <onyx-dropdown
                data-testid="fuel-types-dropdown"
                [formControl]="controls.fuelTypes!"
                [options]="fuelTypes$ | async"
                [multiple]="true"
                [search]="true"
                [size]="32"
                [showErrors]="false"
              ></onyx-dropdown>
            }
          </div>
        }

        <!-- TEMP: Wait for BE implementation -->
        <!-- @if (shouldDisplayControl(controls.hasEcmr)) {
          <onyx-toggle
            data-testid="has-ecmr-toggle"
            [formControl]="controls.hasEcmr!"
            label="labels.ecmr"
          ></onyx-toggle>
        } -->

        @if (shouldDisplayControl(controls.isExpress)) {
          <onyx-toggle
            data-testid="is-express-toggle"
            [style.order]="order()['labels.isExpress']"
            [formControl]="controls.isExpress!"
            label="labels.isExpress"
            [size]="32"
          ></onyx-toggle>
        }

        @if (shouldDisplayControl(controls.hasHaccp)) {
          <onyx-toggle
            data-testid="has-haccp-toggle"
            [style.order]="order()['labels.haccp']"
            [formControl]="controls.hasHaccp"
            label="labels.haccp"
            [size]="32"
          ></onyx-toggle>
        }

        @if (
          showHooksNumber() &&
          shouldDisplayControl(controls.hooksNumber, { conditional: true })
        ) {
          <div class="item" [style.order]="order()['labels.hooks']">
            <onyx-toggle
              data-testid="has-hooks-number-toggle"
              [(checked)]="hasHooksNumber"
              label="labels.hooks"
              [size]="32"
              [disabled]="readonly()"
            ></onyx-toggle>

            @if (hasHooksNumber()) {
              <onyx-text-field
                data-testid="hooks-number-field"
                [formControl]="controls.hooksNumber"
                placeholder="0"
                [decimalPlaces]="0"
                unit="units.pieces"
                [size]="32"
                [showErrors]="false"
              ></onyx-text-field>
            }
          </div>
        }

        @if (shouldDisplayControl(controls.hasHdsCrane)) {
          <onyx-toggle
            data-testid="has-hds-crane-toggle"
            [style.order]="order()['labels.hdsCrane']"
            [formControl]="controls.hasHdsCrane"
            label="labels.hdsCrane"
            [size]="32"
          ></onyx-toggle>
        }

        @if (
          isOrder &&
          shouldDisplayControl(controls.driverLanguages, { conditional: true })
        ) {
          <div class="item" [style.order]="order()['labels.foreignLanguages']">
            <onyx-toggle
              data-testid="has-driver-languages-toggle"
              [(checked)]="hasDriverLanguages"
              label="labels.foreignLanguages"
              [size]="32"
              [disabled]="readonly()"
            ></onyx-toggle>

            @if (hasDriverLanguages()) {
              <onyx-dropdown
                data-testid="driver-languages-dropdown"
                [formControl]="controls.driverLanguages!"
                [options]="languages$ | async"
                [multiple]="true"
                [search]="true"
                [size]="32"
                [showErrors]="false"
              ></onyx-dropdown>
            }
          </div>
        }

        @if (shouldDisplayControl(controls.hasCustomsSecuringRope)) {
          <onyx-toggle
            data-testid="has-customs-securing-rope-toggle"
            [style.order]="order()['labels.customsSecuringRope']"
            [formControl]="controls.hasCustomsSecuringRope"
            label="labels.customsSecuringRope"
            [size]="32"
          ></onyx-toggle>
        }

        @if (
          showMatsNumber() &&
          shouldDisplayControl(controls.matsNumber, { conditional: true })
        ) {
          <div class="item" [style.order]="order()['labels.mats']">
            <onyx-toggle
              data-testid="has-mats-number-toggle"
              [(checked)]="hasMatsNumber"
              label="labels.mats"
              [size]="32"
              [disabled]="readonly()"
            ></onyx-toggle>

            @if (hasMatsNumber()) {
              <onyx-text-field
                data-testid="mats-number-field"
                [formControl]="controls.matsNumber"
                placeholder="0"
                [decimalPlaces]="0"
                unit="units.pieces"
                [size]="32"
                [showErrors]="false"
              ></onyx-text-field>
            }
          </div>
        }

        @if (showCoilWellLength() && controls.coilWellLength) {
          <div class="item" [style.order]="order()['labels.coilWell']">
            <onyx-toggle
              data-testid="has-coil-well-length-toggle"
              [(checked)]="hasCoilWellLength"
              label="labels.coilWell"
              [size]="32"
              [disabled]="readonly()"
            ></onyx-toggle>

            @if (hasCoilWellLength()) {
              <onyx-text-field
                data-testid="coil-well-length-field"
                [formControl]="controls.coilWellLength"
                [warning]="
                  controls.coilWellLength.value | unitWarning: 'cargoLength'
                "
                placeholder="0"
                [decimalPlaces]="2"
                unit="m"
                [size]="32"
                [showErrors]="false"
              ></onyx-text-field>
            }
          </div>
        }

        @if (shouldDisplayControl(controls.isExclusive)) {
          <div class="tooltip-item" [style.order]="order()['labels.exclusive']">
            <onyx-toggle
              data-testid="is-exclusive-toggle"
              [formControl]="controls.isExclusive!"
              label="labels.exclusive"
              [size]="32"
              [showErrors]="false"
            ></onyx-toggle>

            <onyx-tooltip
              [tooltip]="`${i18n()}.exclusiveTooltip` | translate"
              [size]="12"
            ></onyx-tooltip>
          </div>
        }

        @if (shouldDisplayControl(controls.hasLoadingsRamps)) {
          <onyx-toggle
            data-testid="has-loading-ramps-toggle"
            [style.order]="order()['labels.loadingRamps']"
            [formControl]="controls.hasLoadingsRamps"
            label="labels.loadingRamps"
            [size]="32"
          ></onyx-toggle>
        }

        @if (
          isOrder &&
          shouldDisplayControl(controls.sentNotificationNumber, {
            conditional: true,
          })
        ) {
          <div class="item" [style.order]="order()['labels.sentNotification']">
            <onyx-toggle
              data-testid="has-sent-notification-number-toggle"
              [(checked)]="hasSentNotificationNumber"
              label="labels.sentNotification"
              [size]="32"
              [disabled]="readonly()"
            ></onyx-toggle>

            @if (hasSentNotificationNumber()) {
              <onyx-text-field
                data-testid="sent-notification-number-field"
                [formControl]="controls.sentNotificationNumber!"
                placeholder="labels.number"
                [size]="32"
                [showErrors]="false"
              ></onyx-text-field>
            }
          </div>
        }

        @if (
          showBeltsNumber() &&
          shouldDisplayControl(controls.beltsNumber, { conditional: true })
        ) {
          <div class="item" [style.order]="order()['labels.belts']">
            <onyx-toggle
              data-testid="has-belts-number-toggle"
              [(checked)]="hasBeltsNumber"
              label="labels.belts"
              [size]="32"
              [disabled]="readonly()"
            ></onyx-toggle>

            @if (hasBeltsNumber()) {
              <onyx-text-field
                data-testid="belts-number-field"
                [formControl]="controls.beltsNumber"
                placeholder="0"
                [decimalPlaces]="0"
                unit="units.pieces"
                [size]="32"
                [showErrors]="false"
              ></onyx-text-field>
            }
          </div>
        }

        @if (shouldDisplayControl(controls.hasDoubleCrew)) {
          <onyx-toggle
            data-testid="has-double-crew-toggle"
            [style.order]="order()['labels.doubleCrew']"
            [formControl]="controls.hasDoubleCrew!"
            label="labels.doubleCrew"
            [size]="32"
          ></onyx-toggle>
        }

        <!-- TEMP: Restore when support ready -->
        <!-- @if (shouldDisplayControl(controls.hasDoubleDeck)) {
          <onyx-toggle
            data-testid="has-double-deck-toggle"
            [formControl]="controls.hasDoubleDeck!"
            label="labels.doubleDeck"
          ></onyx-toggle>
        } -->

        @if (shouldDisplayControl(controls.hasSanitaryInspection)) {
          <onyx-toggle
            data-testid="has-sanitary-inspection-toggle"
            [style.order]="order()['labels.sanitaryInspection']"
            [formControl]="controls.hasSanitaryInspection"
            label="labels.sanitaryInspection"
            [size]="32"
          ></onyx-toggle>
        }

        @if (
          showTemperatureRange() &&
          shouldDisplayControl(controls.temperatureRange, { conditional: true })
        ) {
          <div class="item" [style.order]="order()['labels.temperature']">
            <onyx-toggle
              data-testid="has-temperature-range-toggle"
              [(checked)]="hasTemperatureRange"
              label="labels.temperature"
              [size]="32"
              [disabled]="
                readonly() || (showTemperatureRange() && hasTemperatureRange())
              "
            ></onyx-toggle>

            @if (hasTemperatureRange()) {
              @let temperatureRangeFormGroup = controls.temperatureRange;
              <div
                class="temperature-range"
                [formGroup]="temperatureRangeFormGroup"
              >
                @let temperatureRangeControls =
                  temperatureRangeFormGroup.controls;
                <onyx-text-field
                  data-testid="temperature-range-from-field"
                  [formControl]="temperatureRangeControls.from"
                  placeholder="labels.from"
                  [decimalPlaces]="0"
                  [acceptNegative]="true"
                  unit="°C"
                  [size]="32"
                  width="64px"
                  [showErrors]="false"
                ></onyx-text-field>

                <span>-</span>

                <onyx-text-field
                  data-testid="temperature-range-to-field"
                  [formControl]="temperatureRangeControls.to"
                  placeholder="labels.to"
                  [decimalPlaces]="0"
                  [acceptNegative]="true"
                  unit="°C"
                  [size]="32"
                  width="64px"
                  [showErrors]="false"
                ></onyx-text-field>
              </div>
            }
          </div>
        }

        @if (showSemiTrailerSize() && controls.semiTrailerSize) {
          <div class="item" [style.order]="order()['labels.semiTrailerSize']">
            <onyx-toggle
              [checked]="true"
              label="labels.semiTrailerSize"
              [size]="32"
              [disabled]="true"
            ></onyx-toggle>

            @let tooltip =
              controls.semiTrailerSize.value === SemiTrailerSize.MEGA
                ? 'tooltips.mega'
                : 'tooltips.standard';
            <onyx-tabs
              data-testid="semi-trailer-size-tabs"
              [formControl]="controls.semiTrailerSize"
              [tabs]="semiTrailerSizes$ | async"
              [onyxTooltip]="`${I18N}.${tooltip}`"
              [onyxTooltipDisabled]="controls.semiTrailerSize.enabled"
            ></onyx-tabs>
          </div>
        }

        @if (showTrailerSize() && controls.trailerSize) {
          <div class="item" [style.order]="order()['labels.trailerFor']">
            <onyx-toggle
              [checked]="true"
              label="labels.trailerFor"
              [size]="32"
              [disabled]="true"
            ></onyx-toggle>

            @let tooltip =
              controls.trailerSize.value === TrailerSize.VAN
                ? 'tooltips.van'
                : 'tooltips.straightTruck';
            <onyx-tabs
              data-testid="trailer-size-tabs"
              [formControl]="controls.trailerSize"
              [tabs]="trailerSizes$ | async"
              [onyxTooltip]="`${I18N}.${tooltip}`"
              [onyxTooltipDisabled]="controls.trailerSize.enabled"
            ></onyx-tabs>
          </div>
        }

        @if (shouldDisplayControl(controls.hasTailLift)) {
          <onyx-toggle
            data-testid="has-tail-lift-toggle"
            [style.order]="order()['labels.tailLift']"
            [formControl]="controls.hasTailLift"
            label="labels.tailLift"
            [size]="32"
          ></onyx-toggle>
        }

        @if (shouldDisplayControl(controls.hasDumpContainer)) {
          <onyx-toggle
            data-testid="has-dump-container-toggle"
            [style.order]="order()['labels.dumpContainer']"
            [formControl]="controls.hasDumpContainer"
            label="labels.dumpContainer"
            [size]="32"
          ></onyx-toggle>
        }

        @if (shouldDisplayControl(controls.hasForklift)) {
          <onyx-toggle
            data-testid="has-forklift-toggle"
            [style.order]="order()['labels.forklift']"
            [formControl]="controls.hasForklift"
            label="labels.forklift"
            [size]="32"
          ></onyx-toggle>
        }

        @if (shouldDisplayControl(controls.hasPalletExchange)) {
          <onyx-toggle
            data-testid="has-pallet-exchange-toggle"
            [style.order]="order()['labels.palletExchange']"
            [formControl]="controls.hasPalletExchange!"
            label="labels.palletExchange"
            [size]="32"
          ></onyx-toggle>
        }
      </div>

      <div class="other-parameters">
        <ng-container
          *ngTemplateOutlet="
            parametersTemplate;
            context: {
              control: controls.otherVehicleParameters,
              label: 'labels.otherVehicleParameters',
              options: vehicleParameters$ | async,
              add: addVehicleParameter.bind(this),
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            parametersTemplate;
            context: {
              control: controls.otherDriverPermissions,
              label: 'labels.otherDriverPermissions',
              options: driverPermissions$ | async,
              add: addDriverPermission.bind(this),
            }
          "
        ></ng-container>

        <ng-template
          let-control="control"
          let-label="label"
          let-options="options"
          let-add="add"
          #parametersTemplate
        >
          @if (shouldDisplayControl(control) && (!isOrder || options?.length)) {
            <onyx-dropdown
              [formControl]="control"
              [label]="label"
              [hint]="`${I18N}.parametersHint`"
              [options]="options"
              [multiple]="true"
              [search]="true"
              [showAddOption]="!isOrder"
              [size]="32"
              (addOption)="!isOrder ? add($event) : null"
            ></onyx-dropdown>
          }
        </ng-template>
      </div>
    </form>

    <p class="empty f-body-m f-muted">{{ `${I18N}.empty` | translate }}</p>
  </div>
</onyx-section>
